if(!customElements.get('collection-grid')) {
  class CollectionGrid extends HTMLElement {
    
    constructor() {
      super();

      this.sectionId = this.getAttribute('id');
      this.currentPage = Number(this.getAttribute('page-current'));
      this.totalPages = Number(this.getAttribute('page-total'));
      this.nextUrl = this.getAttribute('page-next');

      this.elProducts = this.querySelector('[data-products]');
      this.elObserver = this.querySelector('[data-observer]');

      this.observer = this.elObserver ? new IntersectionObserver(this.paginateCollection.bind(this)).observe(this.elObserver) : null;
    }

    paginateCollection([entry], observer) {
      if (entry.isIntersecting && this.currentPage < this.totalPages) {
        this.elProducts.setAttribute('aria-busy', true);
        this.setCollection(this.nextUrl, true);
      }
    }

    setCollection(url, shouldAppend) {
      this.loadCollection(url)
        .then(data => {
          this.currentPage = data.currentPage;
          this.nextPage = data.nextPage;

          !shouldAppend && (this.elProducts.innerHTML = '');
          data.products.forEach(el => {
            this.elProducts.appendChild(el);
          })

          this.elProducts.setAttribute('aria-busy', false);
          window.initLazyLoad();
        })
        .catch(err => {
          console.log(err);
          this.elProducts.setAttribute('aria-busy', false);
        })
    }

    async loadCollection(url) {
      const response = await fetch(url);
      const data = await response.text();

      const html = document.createElement("html");
      html.innerHTML = data;

      const elGrid = html.querySelector(`#${this.sectionId}`);
      const elProducts = elGrid.querySelector('[data-products]');
      const elProductCards = [...elProducts.querySelectorAll('[data-product]')];

      return {
        currentPage: elGrid.getAttribute('page-current'),
        nextPage: elGrid.getAttribute('page-next'),
        products: elProductCards,
      };
    }

  }

  customElements.define('collection-grid', CollectionGrid);
}